import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DESCIPTION_BASE_TIMELINE, FRONT_URL, TITLE_TIMELINE } from 'src/app/constant/app-constant';
import { CanonicalService } from 'src/app/service/canonical/canonical.service';
import { MetaTagsService } from 'src/app/service/meta-tag/meta-tags.service';
import { TimelineService } from 'src/app/service/timeline/timeline.service';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

declare var adsbygoogle: any[];
@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  mobile_news_div = false
  lap_news_div = false
  hideads = true
  notfound = false;
  TimeLineNews = new Array()
  TimelinePostPagination = new Array()
  row_count: number = 100;
  config: any;
  collection = { count: 60, data: [] };
  value = 0
  time_frame: string = ""

  date!: number;
  month!: number;
  year!: number;

  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public isLastPage: boolean = false
  public labels: any = {
    nextLabel: "Next",
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };
  constructor(private timelineService: TimelineService,
    private activateRoute: ActivatedRoute,
    private router: Router,
    private title: Title,
    private meta: Meta,
    private canonicalService: CanonicalService,
    @Inject(DOCUMENT) private document: Document,
    private metaService: MetaTagsService) {
    this.config = {
      itemsPerPage: 5,
      currentPage: 1,
      totalItems: this.collection.count
    };
  }

  ngOnInit() {

    this.canonicalService.destroyLinkForCanonicalURL()
    this.canonicalService.setCanonicalURL();
    this.metaService.setOgTags(TITLE_TIMELINE, DESCIPTION_BASE_TIMELINE, 'https://cdn.newsfirst.lk/assets/TV-BG.jpg', "/featured");

    this.getActiveRoute();

    if (this.date !== 0) {
      this.getTimelineNewsByDate(this.year, this.month, this.date, 0, 5);
    } else if (this.month !== 0) {
      this.getTimelineNewsByMonth(this.year, this.month, 0, 5);
    } else {
      this.getTimelineNewsByYear(this.year, 0, 5);
    }
    this.meta.updateTag(
      { name: 'description', content: DESCIPTION_BASE_TIMELINE }
    )
    for (let index = 0; index < 10; index++) {
      try {
        (adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        // console.error("error");
      }

    }
  }

  getPostByPaginationByDate(year: number, month: number, date: number, page: number, limit: number) {
    this.timelineService.getPostByPaginationByDate(year, month, date, page, limit).subscribe((resp: any) => {

      this.TimelinePostPagination = resp.postResponseDto
      this.collection.data = resp.postResponseDto
      this.collection.count = resp.rowCount
      this.config = {
        itemsPerPage: limit,
        currentPage: page,
        totalItems: resp.rowCount
      };

    })
  }

  getPostByPaginationByMonth(year: number, month: number, page: number, limit: number) {
    this.timelineService.getPostByPaginationByMonth(year, month, page, limit).subscribe((resp: any) => {

      this.TimelinePostPagination = resp.postResponseDto
      this.collection.data = resp.postResponseDto
      this.collection.count = resp.rowCount
      this.config = {
        itemsPerPage: limit,
        currentPage: page,
        totalItems: resp.rowCount
      };

    })
  }

  getPostByPaginationByYear(year: number, page: number, limit: number) {
    this.timelineService.getPostByPaginationByYear(year, page, limit).subscribe((resp: any) => {

      this.TimelinePostPagination = resp.postResponseDto
      this.collection.data = resp.postResponseDto
      this.collection.count = resp.rowCount
      this.config = {
        itemsPerPage: limit,
        currentPage: page,
        totalItems: resp.rowCount
      };

    })
  }

  getTimelineNewsByDate(year: number, month: number, date: number, page: number, limit: number) {
    this.timelineService.getTimelineNewsByDate(year, month, date, page, limit).subscribe((resp: any) => {

      const monthName = this.getMonthName(this.month);
      this.title.setTitle(monthName + ' ' + this.date + ', ' + this.year + TITLE_TIMELINE);
      this.time_frame = 'Daily archive for ' + monthName + ' ' + this.date + ', ' + this.year;
      this.row_count = resp.rowCount
      this.TimeLineNews = resp.postResponseDto
      console.log('row count front ' + this.row_count);

      if (this.row_count >= 6) {
        this.getPostByPaginationByDate(this.year, this.month, this.date, 1, 5)
      }

    }, ((error) => {
      if (error.status == 500) {
        this.notFound();
      }
    }))
  }

  getTimelineNewsByMonth(year: number, month: number, page: number, limit: number) {
    this.timelineService.getTimelineNewsByMonth(year, month, page, limit).subscribe((resp: any) => {

      const monthName = this.getMonthName(this.month);
      this.title.setTitle(monthName + ' ' + this.year + TITLE_TIMELINE);
      this.time_frame = 'Monthly archive for ' + monthName + ' ' + this.year;
      this.row_count = resp.rowCount
      this.TimeLineNews = resp.postResponseDto
      console.log('row count front ' + this.row_count);

      if (this.row_count >= 6) {
        this.getPostByPaginationByMonth(this.year, this.month, 1, 5)
      }

    }, ((error) => {
      if (error.status == 500) {
        this.notFound();
      }
    }))
  }

  getTimelineNewsByYear(year: number, page: number, limit: number) {
    this.timelineService.getTimelineNewsByYear(year, page, limit).subscribe((resp: any) => {

      this.title.setTitle(this.year + TITLE_TIMELINE);
      this.time_frame = 'Yearly archive for ' + this.year;
      this.row_count = resp.rowCount
      this.TimeLineNews = resp.postResponseDto
      console.log('row count front ' + this.row_count + ' | ' + resp.rowCount + ' | ' + year);


      if (resp.rowCount >= 6) {
        this.getPostByPaginationByYear(this.year, 1, 5)
      }

    }, ((error) => {
      if (error.status == 500) {
        this.notFound();
      }
    }))
  }

  replaceString(str: string) {

    return str.replace(/(<([^>]+)>)/ig, '');
  }

  pageChanged(event: any) {
    console.log("this.isLastPage  :  ", this.isLastPage);

    this.config.currentPage = event;


    if (this.date !== 0) {
      console.log('current pagination number : ' + event);
      this.getPostByPaginationByDate(this.year, this.month, this.date, event, 5)
    } else if (this.month !== 0) {
      console.log('current pagination number : ' + event);
      this.getPostByPaginationByMonth(this.year, this.month, event, 5)
    } else {
      console.log('current pagination number : ' + event);
      this.getPostByPaginationByYear(this.year, event, 5)
    }

    const element = document.getElementById("test2");

    if (element != null) {
      element.scrollIntoView(true);
    }
  }

  postId(id: any) {

  }

  getMonthName(monthNumber: number) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('en-US', { month: 'long' });
  }

  titleMeta() {

    this.getActiveRoute();

    let monthName = '';

    const date = new Date();
    date.setMonth(this.month - 1);

    monthName = date.toLocaleString('en-US', { month: 'long' });
    console.log(monthName);

    if (this.date !== 0) {
      return monthName + ' ' + this.date + ', ' + this.year;
    } else if (this.month !== 0) {
      return monthName + ' ' + this.year;
    } else {
      return this.year;
    }
  }

  timeFrame() {
    this.getActiveRoute();

    if (this.date !== 0) {
      return 'Daily';
    } else if (this.month !== 0) {
      return 'Monthly';
    } else {
      return 'Yearly';
    }
  }

  getActiveRoute() {
    this.year = Number(this.activateRoute.snapshot.paramMap.get('year'));
    this.month = Number(this.activateRoute.snapshot.paramMap.get('month'));
    this.date = Number(this.activateRoute.snapshot.paramMap.get('day'));
  }

  notFound() {
    this.title.setTitle('Page Not Found' + TITLE_TIMELINE);
    this.notfound = true;
    var timeleft = 5;
    var downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        this.document.getElementById("countdown")!.innerHTML = "Redirecting now....";
        this.document.location.href = FRONT_URL;
      } else {
        this.document.getElementById("countdown")!.innerHTML = "Redirecting : " + timeleft + " seconds.";
      }
      timeleft -= 1;
    }, 1000);
  }


}
